module.exports = __webpack_public_path__ + "img/rupee.3c4f5ccf.svg";